(function () {
function $6fcc79c6c64a3498$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $6fcc79c6c64a3498$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $6fcc79c6c64a3498$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $6fcc79c6c64a3498$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


function $e888ca0329c829a8$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $64a576ca60cdd755$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $33b98f7adee0c30f$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $365e441adf496b10$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $4d8b33cf7ea22330$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $365e441adf496b10$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $365e441adf496b10$export$71511d61b312f219)(o, minLen);
}


function $44374ae7d76466ff$export$71511d61b312f219(arr, i) {
    return (0, $e888ca0329c829a8$export$71511d61b312f219)(arr) || (0, $64a576ca60cdd755$export$71511d61b312f219)(arr, i) || (0, $4d8b33cf7ea22330$export$71511d61b312f219)(arr, i) || (0, $33b98f7adee0c30f$export$71511d61b312f219)();
}


function $c90cea3003119661$export$71511d61b312f219(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}


function $a5b4005eccd56cff$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $4cbc9d052062a1bc$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $a5b4005eccd56cff$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $4cbc9d052062a1bc$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $a5b4005eccd56cff$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $4cbc9d052062a1bc$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $a5b4005eccd56cff$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $96a38ea9b8ec37c1$export$8960430cfd85939f = Math.max;
var $96a38ea9b8ec37c1$export$96ec731ed4dcb222 = Math.min;
var $96a38ea9b8ec37c1$export$2077e0241d6afd3c = Math.round;



function $cce9499e97f2a074$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $d7b9e6691ade23a3$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $cce9499e97f2a074$export$2e2bcd8739ae039)());
}


function $bd373cee60707f1a$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $4cbc9d052062a1bc$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $96a38ea9b8ec37c1$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $96a38ea9b8ec37c1$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $4cbc9d052062a1bc$export$45a5e7f76e0caa8d)(element) ? (0, $a5b4005eccd56cff$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $d7b9e6691ade23a3$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $1150df8a44fad6cd$export$2e2bcd8739ae039(node) {
    var win = (0, $a5b4005eccd56cff$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $f0c88a8f7a057947$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $f4c9df318396f6aa$export$2e2bcd8739ae039(node) {
    if (node === (0, $a5b4005eccd56cff$export$2e2bcd8739ae039)(node) || !(0, $4cbc9d052062a1bc$export$1b3bfaa9684536aa)(node)) return (0, $1150df8a44fad6cd$export$2e2bcd8739ae039)(node);
    else return (0, $f0c88a8f7a057947$export$2e2bcd8739ae039)(node);
}


function $1836de9dcb9faaba$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $089accca0a43a9fa$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $4cbc9d052062a1bc$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $cf263653acef7133$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $bd373cee60707f1a$export$2e2bcd8739ae039)((0, $089accca0a43a9fa$export$2e2bcd8739ae039)(element)).left + (0, $1150df8a44fad6cd$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $e22b590633770210$export$2e2bcd8739ae039(element) {
    return (0, $a5b4005eccd56cff$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $86677918f5dd2b75$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $e22b590633770210$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $4f0c4f9df6120e6d$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $96a38ea9b8ec37c1$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $96a38ea9b8ec37c1$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $4f0c4f9df6120e6d$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $4cbc9d052062a1bc$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $4cbc9d052062a1bc$export$1b3bfaa9684536aa)(offsetParent) && $4f0c4f9df6120e6d$var$isElementScaled(offsetParent);
    var documentElement = (0, $089accca0a43a9fa$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $bd373cee60707f1a$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $1836de9dcb9faaba$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $86677918f5dd2b75$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $f4c9df318396f6aa$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $4cbc9d052062a1bc$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $bd373cee60707f1a$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $cf263653acef7133$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $5ac95f85b23af861$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $bd373cee60707f1a$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $0b1d71cc799be8b5$export$2e2bcd8739ae039(element) {
    if ((0, $1836de9dcb9faaba$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $4cbc9d052062a1bc$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $089accca0a43a9fa$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $0ed6a088864242e9$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $1836de9dcb9faaba$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $4cbc9d052062a1bc$export$1b3bfaa9684536aa)(node) && (0, $86677918f5dd2b75$export$2e2bcd8739ae039)(node)) return node;
    return $0ed6a088864242e9$export$2e2bcd8739ae039((0, $0b1d71cc799be8b5$export$2e2bcd8739ae039)(node));
}





function $bee5e324511d7142$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $0ed6a088864242e9$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $a5b4005eccd56cff$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $86677918f5dd2b75$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($bee5e324511d7142$export$2e2bcd8739ae039((0, $0b1d71cc799be8b5$export$2e2bcd8739ae039)(target)));
}







function $5d372b183c48539d$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $1836de9dcb9faaba$export$2e2bcd8739ae039)(element)) >= 0;
}




function $d24eb6bac87fb51d$var$getTrueOffsetParent(element) {
    if (!(0, $4cbc9d052062a1bc$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $e22b590633770210$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $d24eb6bac87fb51d$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $cce9499e97f2a074$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $cce9499e97f2a074$export$2e2bcd8739ae039)());
    if (isIE && (0, $4cbc9d052062a1bc$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $e22b590633770210$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $0b1d71cc799be8b5$export$2e2bcd8739ae039)(element);
    if ((0, $4cbc9d052062a1bc$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $4cbc9d052062a1bc$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $1836de9dcb9faaba$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $e22b590633770210$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $d24eb6bac87fb51d$export$2e2bcd8739ae039(element) {
    var window = (0, $a5b4005eccd56cff$export$2e2bcd8739ae039)(element);
    var offsetParent = $d24eb6bac87fb51d$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $5d372b183c48539d$export$2e2bcd8739ae039)(offsetParent) && (0, $e22b590633770210$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $d24eb6bac87fb51d$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $1836de9dcb9faaba$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $1836de9dcb9faaba$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $e22b590633770210$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $d24eb6bac87fb51d$var$getContainingBlock(element) || window;
}


var $ae43d277f8ee9d0f$export$1e95b668f3b82d = 'top';
var $ae43d277f8ee9d0f$export$40e543e69a8b3fbb = 'bottom';
var $ae43d277f8ee9d0f$export$79ffe56a765070d2 = 'right';
var $ae43d277f8ee9d0f$export$eabcd2c8791e7bf4 = 'left';
var $ae43d277f8ee9d0f$export$dfb5619354ba860 = 'auto';
var $ae43d277f8ee9d0f$export$aec2ce47c367b8c3 = [
    $ae43d277f8ee9d0f$export$1e95b668f3b82d,
    $ae43d277f8ee9d0f$export$40e543e69a8b3fbb,
    $ae43d277f8ee9d0f$export$79ffe56a765070d2,
    $ae43d277f8ee9d0f$export$eabcd2c8791e7bf4
];
var $ae43d277f8ee9d0f$export$b3571188c770cc5a = 'start';
var $ae43d277f8ee9d0f$export$bd5df0f255a350f8 = 'end';
var $ae43d277f8ee9d0f$export$390fd549c5303b4d = 'clippingParents';
var $ae43d277f8ee9d0f$export$d7b7311ec04a3e8f = 'viewport';
var $ae43d277f8ee9d0f$export$ae5ab1c730825774 = 'popper';
var $ae43d277f8ee9d0f$export$ca50aac9f3ba507f = 'reference';
var $ae43d277f8ee9d0f$export$368f9a87e87fa4e1 = /*#__PURE__*/ $ae43d277f8ee9d0f$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $ae43d277f8ee9d0f$export$b3571188c770cc5a,
        placement + "-" + $ae43d277f8ee9d0f$export$bd5df0f255a350f8
    ]);
}, []);
var $ae43d277f8ee9d0f$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($ae43d277f8ee9d0f$export$aec2ce47c367b8c3, [
    $ae43d277f8ee9d0f$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $ae43d277f8ee9d0f$export$b3571188c770cc5a,
        placement + "-" + $ae43d277f8ee9d0f$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $ae43d277f8ee9d0f$export$421679a7c3d56e = 'beforeRead';
var $ae43d277f8ee9d0f$export$aafa59e2e03f2942 = 'read';
var $ae43d277f8ee9d0f$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $ae43d277f8ee9d0f$export$c65e99957a05207c = 'beforeMain';
var $ae43d277f8ee9d0f$export$f22da7240b7add18 = 'main';
var $ae43d277f8ee9d0f$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $ae43d277f8ee9d0f$export$8d4d2d70e7d46032 = 'beforeWrite';
var $ae43d277f8ee9d0f$export$68d8715fc104d294 = 'write';
var $ae43d277f8ee9d0f$export$70a6e5159acce2e6 = 'afterWrite';
var $ae43d277f8ee9d0f$export$d087d3878fdf71d5 = [
    $ae43d277f8ee9d0f$export$421679a7c3d56e,
    $ae43d277f8ee9d0f$export$aafa59e2e03f2942,
    $ae43d277f8ee9d0f$export$6964f6c886723980,
    $ae43d277f8ee9d0f$export$c65e99957a05207c,
    $ae43d277f8ee9d0f$export$f22da7240b7add18,
    $ae43d277f8ee9d0f$export$bab79516f2d662fe,
    $ae43d277f8ee9d0f$export$8d4d2d70e7d46032,
    $ae43d277f8ee9d0f$export$68d8715fc104d294,
    $ae43d277f8ee9d0f$export$70a6e5159acce2e6
];


function $1eb4408fd9d891a6$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $1eb4408fd9d891a6$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $1eb4408fd9d891a6$var$order(modifiers); // order based on phase
    return (0, $ae43d277f8ee9d0f$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $5f1928641cfdc9bd$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $7acd04b3f982ce42$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $9a70ebb0a2a9d742$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $9a70ebb0a2a9d742$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $9a70ebb0a2a9d742$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $9a70ebb0a2a9d742$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $9a70ebb0a2a9d742$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var _$options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, _$options);
                state.scrollParents = {
                    reference: (0, $4cbc9d052062a1bc$export$45a5e7f76e0caa8d)(reference) ? (0, $bee5e324511d7142$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $bee5e324511d7142$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $bee5e324511d7142$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $1eb4408fd9d891a6$export$2e2bcd8739ae039)((0, $7acd04b3f982ce42$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, _$reference = _state$elements.reference, _$popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$9a70ebb0a2a9d742$var$areValidElements(_$reference, _$popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $4f0c4f9df6120e6d$export$2e2bcd8739ae039)(_$reference, (0, $d24eb6bac87fb51d$export$2e2bcd8739ae039)(_$popper), state.options.strategy === 'fixed'),
                    popper: (0, $5ac95f85b23af861$export$2e2bcd8739ae039)(_$popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $5f1928641cfdc9bd$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$9a70ebb0a2a9d742$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, _$options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: _$options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $9a70ebb0a2a9d742$export$8f7491d57c8f97a9 = /*#__PURE__*/ $9a70ebb0a2a9d742$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $80425559ce6de383$var$passive = {
    passive: true
};
function $80425559ce6de383$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $a5b4005eccd56cff$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $80425559ce6de383$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $80425559ce6de383$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $80425559ce6de383$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $80425559ce6de383$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $80425559ce6de383$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $80425559ce6de383$var$effect,
    data: {}
};



function $a2b5a5d9ab18942c$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $f73143523cbb6db0$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $ac3820c75beefa16$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $61053eea86816848$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $a2b5a5d9ab18942c$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $f73143523cbb6db0$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $ae43d277f8ee9d0f$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $ae43d277f8ee9d0f$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $ae43d277f8ee9d0f$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $ae43d277f8ee9d0f$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $ac3820c75beefa16$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $ae43d277f8ee9d0f$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $ae43d277f8ee9d0f$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $e8de9a20b433f4cb$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $61053eea86816848$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e8de9a20b433f4cb$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $e8de9a20b433f4cb$var$popperOffsets,
    data: {}
};










var $0ad7772e74495c8b$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $0ad7772e74495c8b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $96a38ea9b8ec37c1$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $96a38ea9b8ec37c1$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $0ad7772e74495c8b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $ae43d277f8ee9d0f$export$eabcd2c8791e7bf4);
    var sideY = (0, $ae43d277f8ee9d0f$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $d24eb6bac87fb51d$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $a5b4005eccd56cff$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $089accca0a43a9fa$export$2e2bcd8739ae039)(popper);
            if ((0, $e22b590633770210$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $ae43d277f8ee9d0f$export$1e95b668f3b82d) || (placement === (0, $ae43d277f8ee9d0f$export$eabcd2c8791e7bf4) || placement === (0, $ae43d277f8ee9d0f$export$79ffe56a765070d2)) && variation === (0, $ae43d277f8ee9d0f$export$bd5df0f255a350f8)) {
            sideY = (0, $ae43d277f8ee9d0f$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $ae43d277f8ee9d0f$export$eabcd2c8791e7bf4) || (placement === (0, $ae43d277f8ee9d0f$export$1e95b668f3b82d) || placement === (0, $ae43d277f8ee9d0f$export$40e543e69a8b3fbb)) && variation === (0, $ae43d277f8ee9d0f$export$bd5df0f255a350f8)) {
            sideX = (0, $ae43d277f8ee9d0f$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $0ad7772e74495c8b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $0ad7772e74495c8b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $a5b4005eccd56cff$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $0ad7772e74495c8b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $a2b5a5d9ab18942c$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $f73143523cbb6db0$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $0ad7772e74495c8b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $0ad7772e74495c8b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $0ad7772e74495c8b$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $0ad7772e74495c8b$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $c722fe1ad42b989b$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $4cbc9d052062a1bc$export$1b3bfaa9684536aa)(element) || !(0, $1836de9dcb9faaba$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $c722fe1ad42b989b$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $4cbc9d052062a1bc$export$1b3bfaa9684536aa)(element) || !(0, $1836de9dcb9faaba$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $c722fe1ad42b989b$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $c722fe1ad42b989b$var$applyStyles,
    effect: $c722fe1ad42b989b$var$effect,
    requires: [
        'computeStyles'
    ]
};


var $b41c744cb227fb1c$export$d34966752335dd47 = [
    (0, $80425559ce6de383$export$2e2bcd8739ae039),
    (0, $e8de9a20b433f4cb$export$2e2bcd8739ae039),
    (0, $0ad7772e74495c8b$export$2e2bcd8739ae039),
    (0, $c722fe1ad42b989b$export$2e2bcd8739ae039)
];
var $b41c744cb227fb1c$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $9a70ebb0a2a9d742$export$ed5e13716264f202)({
    defaultModifiers: $b41c744cb227fb1c$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $3638e40b89a76221$var$GOOD = "&#x2713";
var $3638e40b89a76221$var$BAD = "&#x2717";
var $3638e40b89a76221$var$UNKNOWN = "?";
var $3638e40b89a76221$var$PING_SUCCESS = "success";
var $3638e40b89a76221$var$PING_NO_RESPONSE_YET = "no response"; // noresponse in css
var $3638e40b89a76221$var$PING_NO_CONNECTION = "no connection"; // noconnection in css
var $3638e40b89a76221$var$PING_TIMEOUT = "timeout";
var $3638e40b89a76221$var$MILLIS_PER_SECOND = 1000;
var $3638e40b89a76221$var$PERIODIC_TEST_PERIOD = 30 * $3638e40b89a76221$var$MILLIS_PER_SECOND;
var $3638e40b89a76221$var$WEBRTC_RETRY_PERIOD = 10 * $3638e40b89a76221$var$MILLIS_PER_SECOND;
var $3638e40b89a76221$var$RECONNECT_WEBRTC_PERIOD = 1800 * $3638e40b89a76221$var$MILLIS_PER_SECOND;
var $3638e40b89a76221$var$TIMEOUTS_BEFORE_RECONNECT = 5;
var $3638e40b89a76221$var$PING_TIMEOUT_MS = 5000;
var $3638e40b89a76221$var$HIGH_LATENCY_MARK_MS = 500;
// == State ==
var $3638e40b89a76221$var$tests = {
    http: $3638e40b89a76221$var$UNKNOWN,
    dns: $3638e40b89a76221$var$UNKNOWN,
    browser: $3638e40b89a76221$var$UNKNOWN,
    webRtc: $3638e40b89a76221$var$UNKNOWN,
    // We assume the internet is working at first since we do not allow the
    // browser to cache this page
    initialLoad: $3638e40b89a76221$var$GOOD
};
// timestamp in millis of next periodic test
var $3638e40b89a76221$var$nextPeriodicTests = Date.now();
var $3638e40b89a76221$var$rtcPeer = null;
var $3638e40b89a76221$var$rtcChannel = null;
// The timestamp of the first ping we sent to this peer
var $3638e40b89a76221$var$millisOfFirstPingToPeer = null;
// The current server's own reported human description of location
var $3638e40b89a76221$var$rtcPeerLocation = null;
// List of all peer connection locations we have connected to and when we connected to
// them (in *seconds* since first ping).
var $3638e40b89a76221$var$rtcPeerLocations = [];
// Timestamp of the last time we attempted to connect
var $3638e40b89a76221$var$lastRtcConnectAttempt = 0;
var $3638e40b89a76221$var$timeoutsWithoutSuccess = 0;
// index 0 in pingResults is this timestamp
// each additional is the next
var $3638e40b89a76221$var$secondOfFirstPing = 0;
// each entry is the latency of the ping or a string if an error
var $3638e40b89a76221$var$pingResults = [];
// Used to ensure the Last RTT is not overwritten with an older response.
var $3638e40b89a76221$var$lastSuccessPingMillis = null;
// Used to only run the DNS tests once.
var $3638e40b89a76221$var$firstTest = true;
var $3638e40b89a76221$var$maxPing = NaN;
var $3638e40b89a76221$var$minPing = NaN;
// Used to compute average round trip time and packet loss.
var $3638e40b89a76221$var$totalRoundTripTime = 0;
var $3638e40b89a76221$var$numSuccessfulPings = 0;
var $3638e40b89a76221$var$numTimeoutPings = 0;
// Holding this to allow for background timers more frequently than once per
// second which prevents gaps in ping requests on at least Firefox
var $3638e40b89a76221$var$AudioContext = window.AudioContext || window.webkitAudioContext;
var $3638e40b89a76221$var$audioContext = function() {
    if ($3638e40b89a76221$var$AudioContext) return new $3638e40b89a76221$var$AudioContext();
}();
// The second div that is currently or most recently display the tooltip
var $3638e40b89a76221$var$tooltipTarget = null;
function $3638e40b89a76221$var$getLastPingTime() {
    return $3638e40b89a76221$var$secondOfFirstPing + $3638e40b89a76221$var$pingResults.length;
}
// Careful, may return a negative number
function $3638e40b89a76221$var$timeSinceFirstPing(sec) {
    return sec - $3638e40b89a76221$var$secondOfFirstPing;
}
function $3638e40b89a76221$var$getPingResultForSecond(sec) {
    var timeSinceFirst = $3638e40b89a76221$var$timeSinceFirstPing(sec);
    if (timeSinceFirst < 0) return "Before first ping";
    return $3638e40b89a76221$var$pingResults[$3638e40b89a76221$var$timeSinceFirstPing(sec)];
}
function $3638e40b89a76221$var$getPingPeerLocationForSecond(pingSec) {
    for(var idx = $3638e40b89a76221$var$rtcPeerLocations.length - 1; idx >= 0; idx--){
        var _rtcPeerLocations_idx = (0, $44374ae7d76466ff$export$71511d61b312f219)($3638e40b89a76221$var$rtcPeerLocations[idx], 2), location_description = _rtcPeerLocations_idx[0], locSec = _rtcPeerLocations_idx[1];
        if (locSec <= pingSec) return location_description;
    }
    return "Unknown";
}
var $3638e40b89a76221$var$tooltip = document.getElementById("tooltip");
function $3638e40b89a76221$var$showTooltip(evt) {
    var div = evt.target;
    $3638e40b89a76221$var$tooltipTarget = div;
    setTimeout(function() {
        if ($3638e40b89a76221$var$tooltipTarget !== div) // We moved away before the timeout
        return;
        var secInMinute = parseInt(div.getAttribute("data-sec"));
        var min = parseInt(div.parentElement.getAttribute("data-minute"));
        var timestampSec = min * 60 + secInMinute;
        var result = $3638e40b89a76221$var$getPingResultForSecond(timestampSec);
        var text = new Date(timestampSec * $3638e40b89a76221$var$MILLIS_PER_SECOND).toLocaleTimeString() + "<br>";
        if (typeof result === "number") {
            text += "Success: " + result.toFixed(1) + " ms<br>";
            text += "From: " + $3638e40b89a76221$var$getPingPeerLocationForSecond(timestampSec);
        } else if (result === $3638e40b89a76221$var$PING_NO_CONNECTION) text += "Establishing a connection...";
        else if (result === $3638e40b89a76221$var$PING_NO_RESPONSE_YET) text += "Waiting for response...";
        else if (result === $3638e40b89a76221$var$PING_TIMEOUT) text += "Timed out waiting for response";
        else // Future second
        return;
        $3638e40b89a76221$var$tooltip.innerHTML = text;
        (0, $b41c744cb227fb1c$export$8f7491d57c8f97a9)(div, $3638e40b89a76221$var$tooltip);
        $3638e40b89a76221$var$tooltip.setAttribute("data-show", "");
    }, 40);
}
function $3638e40b89a76221$var$hideTooltip() {
    $3638e40b89a76221$var$tooltipTarget = null;
    $3638e40b89a76221$var$tooltip.removeAttribute("data-show");
}
function $3638e40b89a76221$var$createNewPingingRow(sec) {
    var _loop = function(i) {
        var _$sec = document.createElement("div");
        _$sec.classList.add("sec");
        _$sec.classList.add("future");
        _$sec.setAttribute("data-sec", String(i));
        var showEvents = [
            "mouseenter",
            "focus"
        ];
        showEvents.forEach(function(event) {
            _$sec.addEventListener(event, $3638e40b89a76221$var$showTooltip);
        });
        var hideEvents = [
            "mouseleave",
            "blur"
        ];
        hideEvents.forEach(function(event) {
            _$sec.addEventListener(event, $3638e40b89a76221$var$hideTooltip);
        });
        row.append(_$sec);
    };
    var row = document.createElement("div");
    row.classList.add("row");
    var date = new Date(sec * $3638e40b89a76221$var$MILLIS_PER_SECOND);
    var toPaddedStr = function(x) {
        return x.toString().padStart(2, "0");
    };
    var minuteLabel = document.createElement("div");
    minuteLabel.classList.add("minuteLabel");
    minuteLabel.textContent = toPaddedStr(date.getHours()) + ":" + toPaddedStr(date.getMinutes());
    row.append(minuteLabel);
    for(var i = 0; i < 60; i++)_loop(i);
    var chart = document.getElementById("pingChart");
    chart.prepend(row);
    return row;
}
function $3638e40b89a76221$var$setPingResultForSecond(sentMillis, result) {
    var nowMillis = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Date.now();
    var elapsed = nowMillis - sentMillis;
    var sec = $3638e40b89a76221$var$millisToWholeSec(sentMillis);
    if ($3638e40b89a76221$var$secondOfFirstPing === 0) $3638e40b89a76221$var$secondOfFirstPing = sec;
    if (result !== $3638e40b89a76221$var$PING_NO_RESPONSE_YET) $3638e40b89a76221$var$log("ping at", new Date(sentMillis).toISOString(), "had result", result, "in", elapsed + "ms");
    var toSave = result;
    if (result === $3638e40b89a76221$var$PING_SUCCESS) toSave = elapsed;
    var previousResult = $3638e40b89a76221$var$pingResults[$3638e40b89a76221$var$timeSinceFirstPing(sec)];
    $3638e40b89a76221$var$pingResults[$3638e40b89a76221$var$timeSinceFirstPing(sec)] = toSave;
    // POSIX Unix timestamp days are guaranteed to be 86400.
    var minutesSinceEpoch = Math.floor(sec / 60);
    var id = "minute" + minutesSinceEpoch;
    var row = document.getElementById(id);
    if (row === null) {
        row = $3638e40b89a76221$var$createNewPingingRow(sec);
        row.id = id;
        row.setAttribute("data-minute", String(minutesSinceEpoch));
    }
    var block = row.querySelector("[data-sec='" + sec % 60 + "']");
    if (block.classList.contains("future") || block.classList.contains("noresponse")) {
        block.classList.remove("future");
        block.classList.remove("noresponse");
        block.classList.add(result.replace(/ /gi, ""));
    }
    if (result == $3638e40b89a76221$var$PING_SUCCESS) {
        var latencyLine = document.createElement("div");
        latencyLine.classList.add("latencyLine");
        var percent = Math.min(Math.max(elapsed / $3638e40b89a76221$var$HIGH_LATENCY_MARK_MS, 0), 1.0);
        // We hard code the height in CSS to be 3em.
        var marginTop = (1 - percent) * 3;
        latencyLine.style.marginTop = "calc(" + marginTop + "em - 2px)";
        block.appendChild(latencyLine);
    }
    if (result == $3638e40b89a76221$var$PING_SUCCESS) {
        if (previousResult === $3638e40b89a76221$var$PING_TIMEOUT) // This is a late result. Undo the earlier timeout count.
        {
            if ($3638e40b89a76221$var$numTimeoutPings > 0) $3638e40b89a76221$var$numTimeoutPings++;
        }
        $3638e40b89a76221$var$updatePingStatsOnSuccess(sentMillis, nowMillis);
    } else if (result == $3638e40b89a76221$var$PING_TIMEOUT) $3638e40b89a76221$var$updatePingStatsOnTimeout();
    // update summary
    var recentSuccess = false;
    for(var i = Math.max(0, $3638e40b89a76221$var$pingResults.length - 3); i < $3638e40b89a76221$var$pingResults.length; i++)if (typeof $3638e40b89a76221$var$pingResults[i] === "number") {
        recentSuccess = true;
        break;
    }
    // Do not count a failure unless we have attempted a few times.
    if (recentSuccess || $3638e40b89a76221$var$pingResults.length > 5) $3638e40b89a76221$var$updateStatus("webRtc", recentSuccess ? $3638e40b89a76221$var$GOOD : $3638e40b89a76221$var$BAD);
}
var $3638e40b89a76221$var$lastRoundTripTimeSpan = document.getElementById("lastRTT");
var $3638e40b89a76221$var$averageRoundTripTimeSpan = document.getElementById("avgRTT");
var $3638e40b89a76221$var$minRoundTripTimeSpan = document.getElementById("minRTT");
var $3638e40b89a76221$var$maxRoundTripTimeSpan = document.getElementById("maxRTT");
function $3638e40b89a76221$var$updatePingStatsOnSuccess(sentMillis, receivedMillis) {
    var rtt = receivedMillis - sentMillis;
    if (sentMillis > receivedMillis) // Or should we skip counting this?
    rtt = 0;
    if (isNaN($3638e40b89a76221$var$minPing) || rtt < $3638e40b89a76221$var$minPing) $3638e40b89a76221$var$minPing = rtt;
    if (isNaN($3638e40b89a76221$var$maxPing) || rtt > $3638e40b89a76221$var$maxPing) $3638e40b89a76221$var$maxPing = rtt;
    $3638e40b89a76221$var$totalRoundTripTime += rtt;
    $3638e40b89a76221$var$numSuccessfulPings++;
    if (!$3638e40b89a76221$var$lastSuccessPingMillis || sentMillis >= $3638e40b89a76221$var$lastSuccessPingMillis) {
        $3638e40b89a76221$var$lastRoundTripTimeSpan.innerHTML = Math.round(rtt) + " ms";
        $3638e40b89a76221$var$lastSuccessPingMillis = sentMillis;
    }
    var avgRTT = Math.round($3638e40b89a76221$var$totalRoundTripTime / $3638e40b89a76221$var$numSuccessfulPings);
    $3638e40b89a76221$var$averageRoundTripTimeSpan.innerHTML = avgRTT + " ms";
    $3638e40b89a76221$var$minRoundTripTimeSpan.innerHTML = Math.round($3638e40b89a76221$var$minPing) + " ms";
    $3638e40b89a76221$var$maxRoundTripTimeSpan.innerHTML = Math.round($3638e40b89a76221$var$maxPing) + " ms";
    $3638e40b89a76221$var$updatePacketLossSpan();
}
function $3638e40b89a76221$var$updatePingStatsOnTimeout() {
    $3638e40b89a76221$var$numTimeoutPings++;
    $3638e40b89a76221$var$updatePacketLossSpan();
}
var $3638e40b89a76221$var$packetLossSpan = document.getElementById("packetLoss");
function $3638e40b89a76221$var$updatePacketLossSpan() {
    var total = $3638e40b89a76221$var$numSuccessfulPings + $3638e40b89a76221$var$numTimeoutPings;
    if (total == 0) return;
    var percent = ($3638e40b89a76221$var$numTimeoutPings / total * 100).toFixed(2);
    $3638e40b89a76221$var$packetLossSpan.innerHTML = String(percent) + "%";
}
function $3638e40b89a76221$var$log() {
    for(var _len = arguments.length, varargs = new Array(_len), _key = 0; _key < _len; _key++){
        varargs[_key] = arguments[_key];
    }
    Function.prototype.bind.call(console.log, console).apply(this, varargs);
}
function $3638e40b89a76221$var$changeSummaryText(state) {
    var newText;
    if (state === "on") newText = "Your internet is <strong>online</strong>";
    else if (state === "off") newText = "Your internet is <strong>offline</strong>";
    else if (state === "unknown") newText = "Your internet is likely <strong>experiencing issues</strong>";
    else {
        newText = "Internal error on pinging. Please report";
        console.error("This is a bug. Please report.");
    }
    var summaryText = document.getElementById("summaryText");
    summaryText.innerHTML = newText;
}
function $3638e40b89a76221$var$updateStatus(which, newState) {
    if ($3638e40b89a76221$var$tests[which] === newState) return;
    $3638e40b89a76221$var$tests[which] = newState;
    document.getElementById(which + "Status").innerHTML = $3638e40b89a76221$var$tests[which];
    var good = 0;
    var bad = 0;
    var check = function(name) {
        var s = $3638e40b89a76221$var$tests[name];
        if (s == $3638e40b89a76221$var$GOOD) good++;
        else if (s == $3638e40b89a76221$var$BAD) bad++;
    };
    check("http");
    check("dns");
    check("webRtc");
    if (good > 0 && bad > 0) $3638e40b89a76221$var$changeSummaryText("unknown");
    else if (good > 0) $3638e40b89a76221$var$changeSummaryText("on");
    else if (bad > 0) $3638e40b89a76221$var$changeSummaryText("off");
    else if ($3638e40b89a76221$var$secondOfFirstPing != 0 && $3638e40b89a76221$var$timeSinceFirstPing($3638e40b89a76221$var$millisToWholeSec(Date.now())) > $3638e40b89a76221$var$millisToWholeSec($3638e40b89a76221$var$PING_TIMEOUT_MS)) // Do not set to unknown for the first few seconds
    $3638e40b89a76221$var$changeSummaryText("unknown");
}
function $3638e40b89a76221$var$updateBrowserOnlineStatus() {
    $3638e40b89a76221$var$log("browser check reports ", navigator.onLine ? "online" : "offline");
    $3638e40b89a76221$var$updateStatus("browser", navigator.onLine ? $3638e40b89a76221$var$GOOD : $3638e40b89a76221$var$BAD);
    $3638e40b89a76221$var$runPeriodicTests();
}
window.addEventListener("online", $3638e40b89a76221$var$updateBrowserOnlineStatus);
window.addEventListener("offline", $3638e40b89a76221$var$updateBrowserOnlineStatus);
$3638e40b89a76221$var$updateBrowserOnlineStatus();
function $3638e40b89a76221$var$testHttpOrDns(testName) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $6fcc79c6c64a3498$export$71511d61b312f219)(function() {
        var isHttpTest, randomNumber, startTime, pong, body, duration, error, duration1;
        return (0, $c90cea3003119661$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    console.assert(testName == "dns" || testName == "http");
                    isHttpTest = testName == "http";
                    randomNumber = Math.round(Math.random() * 10000000);
                    startTime = Date.now();
                    if (isHttpTest) pong = fetch("/api/ping", {
                        method: "POST",
                        body: randomNumber.toString(),
                        cache: "no-store"
                    });
                    else pong = fetch("https://" + randomNumber + "dns-check." + window.location.hostname + "/api/dns-check", {
                        method: "GET",
                        cache: "no-store"
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        pong
                    ];
                case 2:
                    return [
                        4,
                        _state.sent().text()
                    ];
                case 3:
                    body = _state.sent();
                    if (body !== randomNumber.toString()) throw "Returned body not expected";
                    duration = Date.now() - startTime;
                    $3638e40b89a76221$var$log(testName.toUpperCase(), "test completed successfully in", duration + "ms");
                    $3638e40b89a76221$var$updateStatus(testName, $3638e40b89a76221$var$GOOD);
                    return [
                        3,
                        5
                    ];
                case 4:
                    error = _state.sent();
                    duration1 = Date.now() - startTime;
                    $3638e40b89a76221$var$log(testName.toUpperCase(), "test FAILED in", duration1 + "ms");
                    console.error(error);
                    $3638e40b89a76221$var$updateStatus(testName, $3638e40b89a76221$var$BAD);
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $3638e40b89a76221$var$runPeriodicTests() {
    $3638e40b89a76221$var$updateStatus("http", $3638e40b89a76221$var$UNKNOWN);
    $3638e40b89a76221$var$testHttpOrDns("http");
    if ($3638e40b89a76221$var$firstTest) {
        $3638e40b89a76221$var$updateStatus("dns", $3638e40b89a76221$var$UNKNOWN);
        $3638e40b89a76221$var$testHttpOrDns("dns");
        $3638e40b89a76221$var$firstTest = false;
    }
    if ($3638e40b89a76221$var$nextPeriodicTests <= Date.now()) $3638e40b89a76221$var$nextPeriodicTests = Date.now() + $3638e40b89a76221$var$PERIODIC_TEST_PERIOD;
}
function $3638e40b89a76221$var$runPeriodicTestsIfNecessaryAndUpdateTimer(nowMillis) {
    if (nowMillis >= $3638e40b89a76221$var$nextPeriodicTests) $3638e40b89a76221$var$runPeriodicTests();
    var secondsLeft = Math.ceil(($3638e40b89a76221$var$nextPeriodicTests - nowMillis) / 1000);
    var span = document.getElementById("timeUntilNextPeriodicTests");
    if (span.textContent != String(secondsLeft)) span.textContent = String(secondsLeft);
}
function $3638e40b89a76221$var$setupRtc() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $6fcc79c6c64a3498$export$71511d61b312f219)(function() {
        var offer, response, resp_json, candidate;
        return (0, $c90cea3003119661$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if ($3638e40b89a76221$var$lastRtcConnectAttempt + $3638e40b89a76221$var$WEBRTC_RETRY_PERIOD > Date.now()) // Do not retry too quickly.
                    return [
                        2
                    ];
                    if ($3638e40b89a76221$var$rtcChannel) $3638e40b89a76221$var$rtcChannel.close();
                    if ($3638e40b89a76221$var$rtcPeer) $3638e40b89a76221$var$rtcPeer.close();
                    if (!RTCPeerConnection) {
                        $3638e40b89a76221$var$log("No RTCPeerConnection");
                        document.getElementById("no-webrtc").style.display = "initial";
                        return [
                            2
                        ];
                    }
                    $3638e40b89a76221$var$log("Attempting to connect via WebRTC");
                    $3638e40b89a76221$var$rtcPeer = new RTCPeerConnection();
                    $3638e40b89a76221$var$rtcPeerLocation = null;
                    $3638e40b89a76221$var$millisOfFirstPingToPeer = null;
                    $3638e40b89a76221$var$rtcChannel = $3638e40b89a76221$var$rtcPeer.createDataChannel("webudp", {
                        ordered: false,
                        maxRetransmits: 0
                    });
                    $3638e40b89a76221$var$lastRtcConnectAttempt = Date.now();
                    $3638e40b89a76221$var$rtcChannel.binaryType = "arraybuffer";
                    $3638e40b89a76221$var$rtcChannel.onerror = function(evt) {
                        $3638e40b89a76221$var$log("Failed to establish WebRTC channel");
                    };
                    $3638e40b89a76221$var$rtcChannel.onmessage = function(evt) {
                        $3638e40b89a76221$var$onPingResponse(evt);
                    };
                    return [
                        4,
                        $3638e40b89a76221$var$rtcPeer.createOffer()
                    ];
                case 1:
                    offer = _state.sent();
                    return [
                        4,
                        $3638e40b89a76221$var$rtcPeer.setLocalDescription(offer)
                    ];
                case 2:
                    _state.sent();
                    return [
                        4,
                        fetch("/new_rtc_session?num_successful=" + $3638e40b89a76221$var$numSuccessfulPings.toString() + "&num_timeout=" + $3638e40b89a76221$var$numTimeoutPings.toString(), {
                            method: "POST",
                            body: $3638e40b89a76221$var$rtcPeer.localDescription.sdp
                        })
                    ];
                case 3:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 4:
                    resp_json = _state.sent();
                    return [
                        4,
                        $3638e40b89a76221$var$rtcPeer.setRemoteDescription(new RTCSessionDescription(resp_json.answer))
                    ];
                case 5:
                    _state.sent();
                    candidate = new RTCIceCandidate(resp_json.candidate);
                    return [
                        4,
                        $3638e40b89a76221$var$rtcPeer.addIceCandidate(candidate)
                    ];
                case 6:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
$3638e40b89a76221$var$setupRtc();
function $3638e40b89a76221$var$millisToWholeSec(millis) {
    return Math.floor(millis / $3638e40b89a76221$var$MILLIS_PER_SECOND);
}
function $3638e40b89a76221$var$sendPing(nowMillis) {
    if (!$3638e40b89a76221$var$rtcChannel || $3638e40b89a76221$var$rtcChannel.readyState !== "open") {
        $3638e40b89a76221$var$setPingResultForSecond(nowMillis, $3638e40b89a76221$var$PING_NO_CONNECTION);
        $3638e40b89a76221$var$setupRtc();
        return;
    }
    // We grab a new timestamp to keep the ping latency as accurate as we can from
    // JS.
    var data = "";
    if (!$3638e40b89a76221$var$rtcPeerLocation) data += "LOC?\n";
    var now = Date.now();
    data += String(now);
    $3638e40b89a76221$var$rtcChannel.send(data);
    if ($3638e40b89a76221$var$millisOfFirstPingToPeer === null) $3638e40b89a76221$var$millisOfFirstPingToPeer = now;
    // Send before setting NO_RESPONSE_YET since setPingResultForSecond might be
    // slow if it has to add a new row.
    $3638e40b89a76221$var$setPingResultForSecond(nowMillis, $3638e40b89a76221$var$PING_NO_RESPONSE_YET);
    // TODO it would be nice to not use a timeout here since the page might be in
    // the background and it seems we only get 1 timer per second. Or maybe we
    // should cancel the timer.
    setTimeout(function() {
        if ($3638e40b89a76221$var$getPingResultForSecond($3638e40b89a76221$var$millisToWholeSec(nowMillis)) === $3638e40b89a76221$var$PING_NO_RESPONSE_YET) {
            $3638e40b89a76221$var$setPingResultForSecond(nowMillis, $3638e40b89a76221$var$PING_TIMEOUT);
            $3638e40b89a76221$var$timeoutsWithoutSuccess++;
            if ($3638e40b89a76221$var$timeoutsWithoutSuccess >= $3638e40b89a76221$var$TIMEOUTS_BEFORE_RECONNECT) $3638e40b89a76221$var$setupRtc();
        }
    }, $3638e40b89a76221$var$PING_TIMEOUT_MS);
}
// Attempt to use an event provided timestamp to get a timestamp that is closer
// to when we received the response packet.
function $3638e40b89a76221$var$getEventTimestamp(evt, nowMillis, sentMillis) {
    if (!evt.timeStamp || !performance.timeOrigin) {
        console.debug("No event time");
        return nowMillis;
    }
    var eventStamp = performance.timeOrigin + evt.timeStamp;
    // The event stamp can be rounded for privacy so only use it if it is older
    // than the timestamp we grabbed.
    if (eventStamp > nowMillis) {
        console.debug("Event time in the future", sentMillis, eventStamp, nowMillis);
        return nowMillis;
    }
    // It also seems to be wrong in some browsers (Firefox on Android) where it is
    // an hour behind so only use it if it isn't before the timestamp we sent the
    // request.
    if (eventStamp < sentMillis) {
        console.debug("Event time too far in past", sentMillis, eventStamp, nowMillis);
        return nowMillis;
    }
    return eventStamp;
}
function $3638e40b89a76221$var$onPingResponse(evt) {
    // Get our timestamp as early as possible to reduce latency calculation error
    var nowMillis = Date.now();
    var lines = evt.data.split("\n");
    // Last line is the timestamp we sent in the request.
    var sentMillis = parseInt(lines.pop());
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // The other lines are metadata
        for(var _iterator = lines[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var line = _step.value;
            // Currently the only known possibility is LOC which is the server location
            if (line.startsWith("LOC:\t")) {
                var newRtcPeerLocation = line.split(":\t")[1];
                if ($3638e40b89a76221$var$rtcPeerLocation === null) {
                    $3638e40b89a76221$var$rtcPeerLocation = newRtcPeerLocation;
                    if ($3638e40b89a76221$var$rtcPeerLocations.length == 0 || $3638e40b89a76221$var$rtcPeerLocations[$3638e40b89a76221$var$rtcPeerLocations.length - 1][0] != $3638e40b89a76221$var$rtcPeerLocation) $3638e40b89a76221$var$rtcPeerLocations.push([
                        $3638e40b89a76221$var$rtcPeerLocation,
                        $3638e40b89a76221$var$millisToWholeSec($3638e40b89a76221$var$millisOfFirstPingToPeer)
                    ]);
                    var pingLocationSpan = document.getElementById("pingLocation");
                    pingLocationSpan.innerHTML = $3638e40b89a76221$var$rtcPeerLocation;
                } else if (newRtcPeerLocation != $3638e40b89a76221$var$rtcPeerLocation) console.error("rtcPeerLocation does not match existing:", newRtcPeerLocation, $3638e40b89a76221$var$rtcPeerLocation);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var receivedMillis = $3638e40b89a76221$var$getEventTimestamp(evt, nowMillis, sentMillis);
    $3638e40b89a76221$var$timeoutsWithoutSuccess = 0;
    $3638e40b89a76221$var$setPingResultForSecond(sentMillis, $3638e40b89a76221$var$PING_SUCCESS, receivedMillis);
    if ($3638e40b89a76221$var$lastRtcConnectAttempt + $3638e40b89a76221$var$RECONNECT_WEBRTC_PERIOD <= Date.now()) {
        $3638e40b89a76221$var$log("Reconnecting WebRTC connection in case the server connection info has updated.");
        $3638e40b89a76221$var$setupRtc();
    }
}
function $3638e40b89a76221$var$sendPingIfNecessary(nowMillis) {
    if ($3638e40b89a76221$var$millisToWholeSec(nowMillis) >= $3638e40b89a76221$var$getLastPingTime()) $3638e40b89a76221$var$sendPing(nowMillis);
}
function $3638e40b89a76221$var$onTimer() {
    var nowMillis = Date.now();
    $3638e40b89a76221$var$runPeriodicTestsIfNecessaryAndUpdateTimer(nowMillis);
    $3638e40b89a76221$var$sendPingIfNecessary(nowMillis);
    nowMillis = Date.now();
    var waitMillis = 1005 - nowMillis % 1000;
    window.setTimeout($3638e40b89a76221$var$onTimer, waitMillis);
}
$3638e40b89a76221$var$onTimer();

})();
//# sourceMappingURL=app.849563f6.js.map
